import { type Brand, make } from 'ts-brand';

/** Shape of the {@link CardSetupSecret} model. */
type CardSetupSecretShape = Readonly<{

  /** Payment identifier. */
  token: string;
}>;

/** Secret required to make a payment. */
export type CardSetupSecret = Brand<CardSetupSecretShape, 'CardSetupSecret'>;

/** Card setup secret constructor. */
export const makeCardSetupSecret = make<CardSetupSecret>();
